
export class AssessmentDataVO {
  constructor(
	  public name: any,
	  public testCd: any,
    public assesmentData: string[],
	  public firstMonth: any,
	  public secondMonth: any,
	  public thirdMonth: any,
	  public fourthMonth: any,
	  public FifthMonth: any,
    public sixthMonth: any,
    public percent: any,
      ) {
      }
  }



// WEBPACK FOOTER //
// ./src/app/shared/model/AssessmentDataVO.model.ts